module.exports = __webpack_public_path__ + "static/media/KMD.6a94155d.svg";